import { GuestNavigation } from '@/components/Organisms/Navigation/GuestNavigation/GuestNavigation';
import { NavMenu } from '@/components/Organisms/Navigation/Menu/NavMenu';
import { NavigationBar } from '@/components/Organisms/Navigation/UserNavigation/NavigationBar';
import { TrialBanner } from '@/components/Organisms/TrialBanner/TrialBanner';
import { useAppContext } from '@/contexts/AppContext/AppContext';
import { useNavigationContext } from '@/contexts/NavigationContext/NavigationContext';
import { useMastheadSize } from '@/hooks/useMastheadSize';
import { useEffect, useRef } from 'react';
import type { FCh } from 'react-fc';
import styled from 'styled-components';

/**
 * This file takes care of handling the overall state of the Navigation.
 * It tries to avoid a global context to avoid whole-app re-renders
 */
export const NavigationWrapper: FCh = ({ children }) => {
    const { isMenuOpen, closeMenu } = useNavigationContext();
    const { user } = useAppContext();
    const headerRef = useRef<HTMLElement>(null);
    useMastheadSize('navigation-header', headerRef);

    useEffect(() => {
        // initial page load. hide the fallback menu
        closeMenu();
    }, []);

    return (
        <>
            <Header ref={headerRef}>
                {user.isGuestUser ? <GuestNavigation /> : <NavigationBar />}
                {user.trialExpiry && <TrialBanner expireDate={new Date(user.trialExpiry)} />}
            </Header>
            {!isMenuOpen && children}
            {(isMenuOpen || isMenuOpen === undefined) && <NavMenu />}
        </>
    );
};

export const MENU_ID = 'nav';
export const ACCOUNT_MENU_ID = 'nav-account';
export const getNavSectionId = (index: number) => `nav-section-${index}`;
export const Header = styled.header`
    view-transition-name: masthead;
    width: 100%;
    z-index: var(--zIndex-navigationBar);
    background-color: var(--cds-color-background);
    position: sticky;
    border-top: solid var(--size-masthead-topBorder) var(--color-NavigationLink-highlight);
    border-bottom: solid var(--size-masthead-bottomBorder) var(--color-lines-subtleDivider);
    anchor-name: --bnef-navigation-header;
    @media print {
        display: none !important;
    }
    top: 0;
`;
